var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 23,
    viewBox: "0 0 53 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6,
    width: 6.99996,
    height: 6.99996,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.00049,
    y: 9.50012,
    width: 7.99996,
    height: 7.99996,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6402 16.295C27.8152 16.82 26.7652 17.18 25.5952 17.18C22.5802 17.18 20.6902 15.05 20.6902 11.84C20.6902 8.63 22.6552 6.47 25.5802 6.47C26.7802 6.47 27.7102 6.755 28.4752 7.22L28.1902 9.095C27.5152 8.585 26.6752 8.18 25.6702 8.18C23.8402 8.18 22.7152 9.575 22.7152 11.825C22.7152 14.105 23.9152 15.455 25.7452 15.455C26.7052 15.455 27.5752 15.11 28.3702 14.585L28.6402 16.295ZM36.4766 13.385C36.4766 15.74 35.0216 17.15 33.0416 17.15C31.0766 17.15 29.6516 15.74 29.6516 13.385C29.6516 11.03 31.0916 9.605 33.0566 9.605C35.0366 9.605 36.4766 11.03 36.4766 13.385ZM34.7216 13.385C34.7216 12.05 34.1216 11.09 33.0416 11.09C31.9766 11.09 31.4066 12.035 31.4066 13.385C31.4066 14.705 31.9916 15.68 33.0416 15.68C34.1516 15.68 34.7216 14.735 34.7216 13.385ZM44.5817 13.175C44.5817 15.875 43.0817 17.075 41.4167 17.075C40.7267 17.075 40.1717 16.955 39.7367 16.79V19.52L37.9367 19.79V9.755H39.4667L39.6317 10.745C40.1417 10.16 40.8467 9.605 41.8517 9.605C43.3667 9.605 44.5817 10.745 44.5817 13.175ZM42.7667 13.28C42.7667 11.885 42.1817 11.195 41.3717 11.195C40.7267 11.195 40.2167 11.6 39.7367 12.215V15.32C40.1717 15.53 40.5167 15.635 41.1317 15.635C42.0617 15.635 42.7667 14.87 42.7667 13.28ZM52.2201 9.755L49.4751 17.39C48.8301 19.175 48.0051 19.73 46.6101 19.73C46.2951 19.73 46.1151 19.7 45.9501 19.655L45.7101 18.17C45.9501 18.23 46.2051 18.275 46.5501 18.275C47.0751 18.275 47.4951 18.035 47.7201 17.51L47.8851 17.03L45.2601 9.89L47.1351 9.65L48.8151 14.81L50.4351 9.755H52.2201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fc28507d7e32c0e4c0747f18fda060f0.svg";
export { ForwardRef as ReactComponent };